<div>
    <app-material-details [arFields$]="arFields$"></app-material-details>
</div>
 
